export const getUTCDateTime = () => {
  const d = new Date();
  // Get UTC date in yyyy-mm-dd HH:mm:ss format
  let UtcDateTime = [
    d.getUTCFullYear(),
    `0${d.getUTCMonth() + 1}`.slice(-2),
    `0${d.getUTCDate()}`.slice(-2),
  ].join('-');

  UtcDateTime += ` ${[
    `0${d.getUTCHours()}`.slice(-2),
    `0${d.getUTCMinutes()}`.slice(-2),
    `0${d.getUTCSeconds()}`.slice(-2),
  ].join(':')}`;
  return UtcDateTime;
};
